import { render } from "./ResizeVMModal.vue?vue&type=template&id=6c89868f&scoped=true"
import script from "./ResizeVMModal.vue?vue&type=script&lang=js"
export * from "./ResizeVMModal.vue?vue&type=script&lang=js"

import "./ResizeVMModal.vue?vue&type=style&index=0&id=6c89868f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c89868f"]])

export default __exports__